/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_No_Outstanding_AmountsInputs */

const en_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No outstanding amounts`)
};

const de_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine offenen Beträge`)
};

const es_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin importes pendientes`)
};

const fr_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun montant impayé`)
};

const nl_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen openstaande bedragen`)
};

const it_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun importo in sospeso`)
};

const pt_br2_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem valores pendentes`)
};

const pl_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak zaległych kwot`)
};

const hu_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincsenek tartozások`)
};

const ro_admin_dashboard_no_outstanding_amounts = /** @type {(inputs: Admin_Dashboard_No_Outstanding_AmountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio suma restanta`)
};

/**
* | output |
* | --- |
* | "No outstanding amounts" |
*
* @param {Admin_Dashboard_No_Outstanding_AmountsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_no_outstanding_amounts = /** @type {((inputs?: Admin_Dashboard_No_Outstanding_AmountsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_No_Outstanding_AmountsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "de") return de_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "es") return es_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "fr") return fr_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "nl") return nl_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "it") return it_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "pl") return pl_admin_dashboard_no_outstanding_amounts(inputs)
	if (locale === "hu") return hu_admin_dashboard_no_outstanding_amounts(inputs)
	return ro_admin_dashboard_no_outstanding_amounts(inputs)
});
export { admin_dashboard_no_outstanding_amounts as "admin.dashboard.no_outstanding_amounts" }